// typings

import { create } from "zustand";

import { IVendasCreditosState } from "@/store-zustand/vendas-creditos/index.d";

// criação da store com Zustand (vendas de créditos)
export const useStoreZustandVendasCreditos = create<IVendasCreditosState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  isModalObservacao: false,
  isModalExcluirVendaCredito: false,
  vendasCreditosCliente: [1],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  vendaCredito: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setVendasCreditosCliente: (vendasCreditosCliente) => set({ vendasCreditosCliente }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setVendaCredito: (vendaCredito) => set({ vendaCredito }),
  setIsModalObservacao: (isModalObservacao) => set({ isModalObservacao }),
  setIsModalExcluirVendaCredito: (isModalExcluirVendaCredito) =>
    set({ isModalExcluirVendaCredito }),
}));
